import {Life} from '../../domain/models/Life'

export type ChangedLife = Life & {
    primaryLifeName?: string
}
